import { useContext } from 'react';
import { ErrorContext, ErrorContextType } from './providers/useErrorProvider';

const useError = (): ErrorContextType => useContext(ErrorContext);

export default useError;
